// utils/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();


  // Function to log in the user
  const login = async (token, userData) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
    setIsLoggedIn(true);
  };

  // Function to log out the user
  const logout = async () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        // Call the logout API
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/user/logout`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // Include the token in the header
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to logout from server");
        }
      }
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Clear local storage and update state
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setUser(null);
      setIsLoggedIn(false);
      navigate("/get-started");
    }
  };

  // Check if user is logged in based on the token
  useEffect(() => {
    const fetchUserFromToken = async () => {
      const token = localStorage.getItem("token");
      const storedUser = localStorage.getItem("user");
      if (token && storedUser) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_SERVER_BASE_URL}/user/validate`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.ok) {
            const data = await response.json();
            setUser(data.user);
            setIsLoggedIn(true);
          } else {
            // If token is invalid, clear everything
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            setUser(null);
            setIsLoggedIn(false);
            navigate("/");
          }
        } catch (error) {
          console.error("Token validation error:", error);
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          setUser(null);
          setIsLoggedIn(false);
          navigate("/");
        }
      } else {
        // Token or user missing in localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setUser(null);
        setIsLoggedIn(false);
      }
    };

    fetchUserFromToken();
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
